module.exports = __webpack_public_path__ + "img/jin.8f03ab11.png";